import { render, staticRenderFns } from "./ClubDesktopInfoModalContent.vue?vue&type=template&id=165ea263&"
import script from "./ClubDesktopInfoModalContent.vue?vue&type=script&lang=js&"
export * from "./ClubDesktopInfoModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165ea263')) {
      api.createRecord('165ea263', component.options)
    } else {
      api.reload('165ea263', component.options)
    }
    module.hot.accept("./ClubDesktopInfoModalContent.vue?vue&type=template&id=165ea263&", function () {
      api.rerender('165ea263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/ClubDesktopInfoModalContent.vue"
export default component.exports